import { PU_RELEATIVE_PATH } from "../config";
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

//**To remove the last 3 digits (i.e) checksum from the Salesforce Org ID */
export function removeOrgIdCheksum(orgID) {
  return orgID.slice(0, -3);
}

export function getApiBaseURL() {
  if (isLocalhost) {
    return "https://localhost:50485/upgradeadminservice/api";
  } else {
    return window.location.origin + "/upgradeadminservice/api";
  }
}

//Empty check condition.
export function isEmpty(val) {
  return val === undefined || val == null || val.length <= 0 ? true : false;
}

//**Format date to display on UI */
export function dateFormatter(inputDate) {
  var date = new Date(inputDate);
  if (date.getFullYear() < 2019) return "N/A";

  var day = date.getDate();
  var month = date.toDateString().substr(4, 3);
  var year = date.getFullYear();
  var timeZome = /\((.*)\)/.exec(date.toString())[1];
  var time =
    ("00" + date.getHours()).slice(-2) +
    ":" +
    ("00" + date.getMinutes()).slice(-2) +
    ":" +
    ("00" + date.getSeconds()).slice(-2);
  return day + "-" + month + "-" + year + " " + time + " (" + timeZome + ")";
}

//**Convert minutes into ** hr ** mins format */
export function convertMinToHour(timeInMinutes) {
  // PU-1423 Duration of package is showing negative number. Mark it as 0 if its negative.(Client Date/Time not accurate).
  if (timeInMinutes < 0) {
    return "0 mins";
  }

  if (timeInMinutes < 60) {
    return timeInMinutes + " mins";
  } else {
    var hours = Math.floor(timeInMinutes / 60);
    var min = timeInMinutes % 60;
    return hours + " hr" + " " + min + " mins";
  }
}
export function getTimeDuration(startDate, endDate) {
  if (
    new Date(endDate).getFullYear() < 2019 &&
    new Date(startDate).getFullYear() > 2019
  ) {
    return this.convertMinToHour(
      Math.round((new Date().getTime() - new Date(startDate).getTime()) / 60000)
    );
  } else {
    return this.convertMinToHour(
      Math.round((new Date(endDate).getTime() - startDate.getTime()) / 60000)
    );
  }
}

//Check if the userType is CongaAdmin.
export function isAdminUser() {
  let userType = localStorage.getItem("user_type");
  if (this.isEmpty(userType)) return false;
  else return userType.toLowerCase() === "congaadmin" ? true : false;
}

// Clear the local storage keys
export function doLogout() {
  sessionStorage.removeItem("state");
  localStorage.removeItem("access_token");
  localStorage.removeItem("org_id");
}

export function logout() {
  let welcomeURL = window.location.origin + PU_RELEATIVE_PATH + "welcome";
  logoutAndRedirectToURL(welcomeURL);
}

//Logout and remove active salesforce sessions for the provided Instance URL and redirect to the passed URL
export function logoutAndRedirectToURL(redirectURL) {
  doLogout();
  var thisTimeout = setTimeout(function() {
    let instanceURL = localStorage.getItem("instanceURL");
    window.location.href = instanceURL +"/secur/logout.jsp";
  }, 100);
  var newWindow = window.open(redirectURL);
  if (!newWindow) {
    clearTimeout(thisTimeout);
    alert("Please allow pop-ups on this site!");
    logoutAndRedirectToURL(redirectURL);
  }
}

//Check if the access token is present and confirm login.
export function isLoggedIn() {
  let authToken = localStorage.getItem("access_token");
  return authToken !== null ? true : false;
}

//Get Organization ID from local storage.
export function getOrgId() {
  return localStorage.getItem("org_id");
}

//Get Organization ID from local storage.
export function getAccessToken() {
  return localStorage.getItem("access_token");
}

export const AccessControlEnum = {
  InstallForAdminOnly: "InstallForAdminOnly",
  InstallForAllUsers: "InstallForAllUsers",
  InstallForCustomProfiles: "InstallForCustomProfiles",
};

// Display "New" beside those packages which are being tagged and newly created for the latest release.
export function checkIsPacakageNew(packageName, status) {
  if (status.IsDepenentPackage) packageName = packageName + "*";

  if (status.ParticipatingPackage) packageName = packageName + " (New)";

  return packageName;
}

// check if the input string has is null or empty then return "-".
export function checkForNullorEmpty(item) {
  if (this.authservice.isEmpty(item)) return "-";
  else return item;
}

export function handleAPIErrors(response) {
  if (response.ok) {
    return response;
  } else if (response.status === 401) {
    doLogout();
    window.location.href =
      window.location.origin + PU_RELEATIVE_PATH + "welcome";
  } else if (response.status === 403) {
    doLogout();
    var error_msg =
      "Insufficient Privileges  - You do not have the required access to perform the Operation. Please contact Conga Upgrade team or your Sys. Administrator";
    window.location.href =
      window.location.origin +
      "/registration/ui/forbidden?error=" +
      response.status +
      "&error_description=" +
      error_msg;
  } else if (response.status === 500) {
    console.log(response.statusText);
    throw Error(response.statusText);
  } else {
    console.log(response.statusText);
    throw Error(response.statusText);
  }
  return response;
}
